module.exports = __webpack_public_path__ + "img/NEW_ORDER.png";